export enum CalendarDayType {
  CLOSED = 'CLOSED',
  LIGHT = 'LIGHT',
}
